module.exports = "/_next/static/images/harikrishnan-998f17b79d118dc789dcb20dbb4aecf2.jpg";